import DOMPurify from 'dompurify';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { getInfoHubHtml } from '../../../../utility/common';

const AskAIPageBanner = () => {
  const [aemHeaderData, setAemHeaderData] = useState(null);
  let lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : 'en';

  useEffect(() => {
    // let aemHeaderURL =
    //   'https://mbqa1.sdc.vzwcorp.com/content/experience-fragments/vsbdr/QA2/en/ai/ask-ai/master.html';
    const aemHeaderURL = `${config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${config.aemUrlEnv}/${lng}/ai/ask-ai/master.html`;
    getInfoHubHtml(aemHeaderURL).then((response) => {
      setAemHeaderData(response?.data);
    });
  }, []);
  return (
    <div>
      <Helmet>
        <link
          // href="https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/css/herobanner.css"
          href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/css/herobanner.css`}
          rel="stylesheet"
          type="text/css"
        ></link>
        <link
          // href="https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/css/common/typography.css"
          href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/css/common/typography.css`}
          rel="stylesheet"
          type="text/css"
        ></link>
        <link
          // href="https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/min/css/common/fonts.min.css"
          href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/min/css/common/fonts.min.css`}
          rel="stylesheet"
          type="text/css"
        ></link>
        <script
          src={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === 'QA1' ? '/QA1' : global.config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/herobanner.js`}
          // src='https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/js/herobanner.js'
          type='text/javascript'
          async
        ></script>
      </Helmet>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(aemHeaderData),
        }}
      ></div>
    </div>
  );
};

export default AskAIPageBanner;
